<template>
  <v-card class="mx-auto" outlined>
    <v-list-item>
      <div class="user-detailbox">
        <v-list-item-avatar color="grey darken-3" height="100" width="100">
          <v-img class="elevation-6" alt="" :src="profile_image"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <div class="text-h5 mb-1">
           <h5 class="user-icon-box top-user-name" :class="gender == 'male' ? 'male-icon' : gender == 'female' ? 'female-icon' : 'default-icon'"> {{ full_name }} </h5>
          </div>
          <v-list-item-title class="mb-4 font-weight-regular mail-icon top-mailbox">
            {{ user_email }}
          </v-list-item-title>
          <v-list-item-subtitle class="text-h7 mb-5">Reward Points:
            <span class="font-bold">{{ reward_points }}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </div>
      <v-card-actions>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-btn icon color="pink">
              <v-img max-height="40" max-width="36" :src="require('@/assets/images/user-img-select.png')">
              </v-img>
            </v-btn>
          </v-flex>
          <v-flex xs12 sm12>
            <v-btn @click="editProfile" outlined rounded text>
              Edit Profile
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-list-item>
  </v-card>
</template>
<script>
import { Auth } from "aws-amplify";
import { GET_PROFILE_DETAIL, GET_REFERRAL_DETAIL } from "../../store/actions.type";
import ApiService from "../../api/api.service";
import JwtService from ".././common/jwt.service";
export default {
  data: () => ({
    profile_image: "",
    users: {},
    name: "",
    full_name: "",
    user_email: "",
    reward_points: 0,
    gender:'',
  }),
  created() {
    Fire.$on("picRefresh", () => {
      this.profilePicture();
    });
  },
  mounted() {
    this.authenticatedUserData();
    Fire.$emit("picRefresh");
  },
  methods: {
    editProfile(evt) {
      evt.preventDefault();
      this.$router.push({ name: "EditProfile" }).catch(()=>{});
    },
    profilePicture() {
      if(this.$store.getters.getProfileDetail.data != undefined){
        this.reward_points = this.$store.getters.getProfileDetail.data.reward_point;
        this.profile_image = this.$store.getters.getProfileDetail.data.photo;
      }
    },
    authenticatedUserData() {
      Auth.currentAuthenticatedUser({
        bypassCache: true
      })
      .then(user => {
        this.full_name = user.attributes["custom:name"];
        this.user_email = user.attributes["email"];
        this.users = user;
        this.gender = user.attributes['custom:gender'];
      })
      .catch(err => {
        this.$router.push({ name: "Login" }).catch(()=>{});
      });
    },
  }
};
</script>
